import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../store';

export const projectsSelector = (state: RootState) => state.projects;

export const currentProjectSelector = (state:RootState) => projectsSelector(state).currentProject;
export const projectDataSelector = (state:RootState) => projectsSelector(state).data;
export const projectsHaveLoadedSelector = (state:RootState) => projectsSelector(state).hasFetched;

export const defaultProjectIdSelector = createSelector([projectDataSelector], (projects) => {
  const defaultProject = projects.find(p => p.isDefault);
  return defaultProject ? defaultProject.id : null;
});

export const currentProjectIdSelector = createSelector([currentProjectSelector], (currentProject) => {
  return currentProject ? currentProject.id : null;
});